import React, {useEffect, useState} from "react";
import {Box, rem, Affix, Button, Transition, useMantineTheme, Dialog, Text, Anchor} from "@mantine/core";
import {useDisclosure, useMediaQuery, useWindowScroll} from '@mantine/hooks';
import { nprogress, NavigationProgress } from '@mantine/nprogress';

import { IconArrowUp } from '@tabler/icons-react';

import MyHeader from "./components/Header";
import MyFooter from "./components/Footer";
import SiteHandler from "./components/SiteHandler";
import {Sites} from "./sites/Sites";

import settings from "./settings.json";
import { modals } from "@mantine/modals";



export default function MainPage() {
    const [scroll, scrollTo] = useWindowScroll();
    const theme = useMantineTheme();
    const mobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

    const [dialogOpened, { open, close }] = useDisclosure(false)



    // @ts-ignore
    let startSite = Sites[window.location.pathname];
    if (window.location.pathname === "/") {
        window.history.pushState(null, "", "/home");
        // @ts-ignore
        startSite = Sites[window.location.pathname];
    }else if (startSite === undefined) {
        window.history.pushState(null, "", "/404");
        startSite = Sites["/404"];
    }
    const [active, setActive] = useState(startSite);

    useEffect(() => {
        // check if popup=false in url

        let url = new URL(window.location.href);
        let popup = url.searchParams.get("popup");
        if (popup === "false") {
            return;
        }
        const t = setTimeout(() => {
            open()
        }, settings.popup_delay);

        return () => clearTimeout(t);
    }, [open])

    useEffect(() => {
        // Update progress bar on scroll
        nprogress.set(scroll.y / (document.documentElement.scrollHeight - window.innerHeight) * 100);
    }, [scroll.y]);

    useEffect(() => {
        scrollTo({ y: 0 })
    }, [active, scrollTo]);

    useEffect(() => {
            if (window.location.pathname === '/') {
                window.history.pushState(null, "", "/home");
                setActive(Sites["/home"]);
            } else {
                // @ts-ignore
                setActive(Sites[window.location.pathname]);
            }
            window.onpopstate = function () {
                if (window.location.pathname === active.link){
                    scrollTo({ y: 0 })
                    return;
                }
                // @ts-ignore
                setActive(Sites[window.location.pathname]);
                nprogress.set(0);
                modals.closeAll()
            }
        }, [active.link, scrollTo]);

    const links = [
        { link: '/home', label: 'Home' },
        { link: '/about', label: 'About' },
        { link: '/kontakt', label: 'Kontakt' },
        { link: '/impressum', label: 'Impressum' },
    ];
    const footerData = [
        {
            title: 'About',
            links: [
                { label: 'Über mich', link: '/about' },
                //{ label: 'Credits', link: '/credits' },
                { label: 'Kontakt', link: '/kontakt' },
                {label: "Spenden", link: settings.donation_url},
            ],
        },
        {
            title: 'Social',
            links: Object.entries(settings.social).filter(([, value]) => value !== null).map(([key, value]) => {
                return {label: key.charAt(0).toUpperCase() + key.slice(1), link: value}
            }),
        }
    ]
    if (settings.impressum) {
        footerData[0].links.push(
            { label: 'Impressum', link: '/impressum' }
        )

    }

    return (
        <div>
            <NavigationProgress />
            <Dialog withBorder opened={dialogOpened} onClose={() => close()} shadow={"xl"} withCloseButton w={rem(500)} position={mobile? {bottom: rem(10), right: rem(20), left: rem(20)}: { bottom: 20, right: 20 }}>
                <Box p="md">
                    <Text size="xl" weight={500}>
                        {settings.popup_header}
                    </Text>
                    <Text size="md" weight={400}>
                        {settings.popup_text_1}
                    </Text>
                    <Text size="md" weight={400}>
                        {settings.popup_text_2}
                    </Text>
                    <Text size="md" weight={400}>
                        {settings.popup_text_3}
                    </Text>
                    <Anchor href={settings.donation_url} target={"_blank"} onClick={(e)=>{
                        e.preventDefault()
                        window.history.pushState(null, "", "/blog/spenden");
                        window.dispatchEvent(new Event('popstate'));
                        close()
                    }}>
                        Mehr Informationen
                    </Anchor>
                    <Button onClick={() => close()} style={{marginTop: rem(10)}} variant="light" c={"black"} fullWidth>
                        Verstanden
                    </Button>
                </Box>
            </Dialog>
            {/* @ts-ignore*/}
            <MyHeader links={links} active={active} />
            <Affix position={{ bottom: rem(20), right: rem(20) }}>
                <Transition transition="slide-up" mounted={scroll.y > 0}>
                    {(transitionStyles) => (
                        <Button
                            leftIcon={<IconArrowUp size="1rem" />}
                            style={transitionStyles}
                            onClick={() => scrollTo({ y: 0 })}
                            variant="light"
                        >
                            Nach oben
                        </Button>
                    )}
                </Transition>
            </Affix>
            <Box p={mobile? "sm": "xl"} style={{paddingTop: rem(90)}}>
                <SiteHandler active={active} />
            </Box>
            {/* @ts-ignore*/}
            <MyFooter data={footerData}/>
        </div>
    );
}
